import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69a151899c1d57001434fd38/standave/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a151899c1d57001434fd38/standave/src/app/about/components/AboutCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a151899c1d57001434fd38/standave/src/app/about/components/AboutHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a151899c1d57001434fd38/standave/src/app/about/components/MissionVisionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a151899c1d57001434fd38/standave/src/app/about/components/WhoWeAreSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a151899c1d57001434fd38/standave/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a151899c1d57001434fd38/standave/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a151899c1d57001434fd38/standave/src/components/ui/AppLogo.tsx");
